import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WarrantyActivationFormService {
  private _activationSuccess: boolean = false;
  private formData: any = {};

  setStepData(step: string, data: any) {
    this.formData[step] = data;
  }

  getStepData(step: string): any {
    return this.formData[step];
  }

  getAllData(): any {
    return this.formData;
  }

  clearData() {
    this.formData = {};
    this._activationSuccess = false;
  }

  get activationSuccess(): boolean {
    return this._activationSuccess;
  }

  set activationSuccess(value: boolean) {
    this._activationSuccess = value;
  }
}
